import { useEffect, useState } from 'react'
import SliderImages from '../../component/CustomSlider/SliderImages'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChevronLeft,
  faChevronRight,
  faPlane
} from '@fortawesome/free-solid-svg-icons'
import AirportDropdown from './Dropdown/AirportDropdown'
import GuestCounter from './Dropdown/GuestCounter'
import DateSelector from './Dropdown/DateSelector'
import './style.css'
import moment from 'moment'
import AirportDropdownFrom from './Dropdown/AirportDropdownFrom'
import axios from 'axios'
import {
  setLoadingFalse,
  setLoadingTrue
} from '../../Config/Actions/loadingActions'
import EndDateSelector from './Dropdown/endDateSelector'
import { useDispatch } from 'react-redux'
const Flights = () => {
  const [sliderImages, setSliderImages] = useState([])
  const [flightsForm, setFlightsForm] = useState([])
  const [tripType, setTripType] = useState('One Way')
  const [selectedFare, setSelectedFare] = useState('Regular')
  const [guestCounterOpen, setGuestCounterOpen] = useState(false)
  const [dateRangeOpen, setDateRangeOpen] = useState(false)
  const [endOpen, setDateEndOpen] = useState(false)
  const [success, setSuccess] = useState(false)
  const [airPortName, setAirPortName] = useState('')
  const dispatch = useDispatch()
  useEffect(() => {
    fetch('/PackageJson/Flights/FlightsImages.json')
      .then(response => response.json())
      .then(data => {
        setSliderImages(data)
      })
      .catch(error => console.error('Error loading JSON:', error))
  }, [])

  useEffect(() => {
    fetch('/PackageJson/Flights/FlightsForm.json')
      .then(response => response.json())
      .then(data => {
        setFlightsForm(data)
      })
      .catch(error => console.error('Error loading JSON:', error))
  }, [])

  const handleChangeTripType = event => {
    setTripType(event.target.value)
  }

  const [formData, setFormData] = useState({
    full_name: '',
    contact: '',
    email: '',
    product_type: 'hotels',
    fromAirport: '',
    ToAirport: '',
    adults: 0,
    children: 0,
    infants: 0,
    travelClass: '',
    departureDate: '',
    returnDate: ''
  })
  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }))
  }
  const totalTravelers = formData.adults + formData.children + formData.infants
  const handleSubmit = async e => {
    e.preventDefault()
    dispatch(setLoadingTrue())
    const FormData = {
      to: formData.email,
      subject: 'Flights',
      fullName: formData.full_name,
      Email: formData.email,
      Contact: formData.contact,
      From: formData.fromAirport,
      To: formData.ToAirport,
      startDate: moment(formData.departureDate).format('DD MMM YYYY'),
      EndDate: moment(formData.returnDate).format('DD MMM YYYY'),
      TripType: tripType,
      fareType: selectedFare,
      TypeDomestic: formData.travelClass,
      Adult: formData.adults,
      Child: formData.children,
      Infant: formData.infants
    }

    try {
      const response = await axios.post(
        'https://arrshiyanatravels.com/api/send_email.php',
        FormData
      )
      dispatch(setLoadingFalse())
      setSuccess(true)
      setTimeout(() => setSuccess(false), 3000)
      setFormData(prevState => ({
        ...prevState,
        full_name: '',
        contact: '',
        email: '',
        product_type: 'hotels',
        fromAirport: '',
        ToAirport: '',
        adults: 0,
        children: 0,
        infants: 0,
        travelClass: '',
        departureDate: '',
        returnDate: ''
      }))
    } catch (error) {
      console.error('Error submitting form:', error)
    }
  }

  const handleOnchangeDate = item => {
    setFormData(prevState => ({
      ...prevState,
      departureDate: item.selection.startDate
    }))
  }
  const handleOnchangeEndOpen = item => {
    setFormData(prevState => ({
      ...prevState,
      returnDate: item.selection.startDate
    }))
  }

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    nextArrow: (
      <div className='arrow right'>
        <FontAwesomeIcon
          icon={faChevronRight}
          style={{ color: '#f8ac19', fontSize: '30px' }}
        />
      </div>
    ),
    prevArrow: (
      <div className='arrow left'>
        <FontAwesomeIcon
          icon={faChevronLeft}
          style={{ color: '#f8ac19', fontSize: '30px' }}
        />
      </div>
    )
  }
  return (
    <div>
      <div
        style={{
          height: '',
          backgroundImage: `url(${flightsForm[0]?.displayBackground})`,
          backgroundPosition: 'center',
          backgroundSize: 'Cover',
          backgroundRepeat: 'no-repeat',
          padding: '10px 0px',
          position: 'relative',
          minHeight: '80vh'
        }}
        className='product-container Flights-container'
      >
        <div className='container'>
          <div className='product-area'>
            <form onSubmit={handleSubmit}>
              <div className='radio-group'>
                <label
                  className={`radio-label ${
                    tripType === 'One Way' ? 'selected' : ''
                  }`}
                >
                  <input
                    type='radio'
                    name='tripType'
                    value='One Way'
                    checked={tripType === 'One Way'}
                    onChange={handleChangeTripType}
                    className='radio-input'
                  />
                  <span className='custom-radio'></span>
                  One Way
                </label>

                <label
                  className={`radio-label ${
                    tripType === 'Round Trip' ? 'selected' : ''
                  }`}
                >
                  <input
                    type='radio'
                    name='tripType'
                    value='Round Trip'
                    checked={tripType === 'Round Trip'}
                    onChange={handleChangeTripType}
                    className='radio-input'
                  />
                  <span className='custom-radio'></span>
                  Round Trip
                </label>
              </div>
              <div className='row'>
                <div className='col-lg-6 col-md-12 col-sm-12 airport-list new-airPort'>
                  <div className='form-group'>
                    <AirportDropdown
                      setFormData={setFormData}
                      formData={formData}
                      label='From'
                      airPortName={airPortName}
                    />
                    <div className='flight-swipe'>
                      <img
                        src='PackageJson/Flights/Images/swap.png'
                        alt='swap.png'
                        width='50px'
                      />
                    </div>
                    <AirportDropdownFrom
                      setFormData={setFormData}
                      formData={formData}
                      label='To'
                    />
                  </div>
                </div>
                <div className='col-lg-6 col-md-12 col-sm-12'>
                  <div className='form-group'>
                    <div
                      className='subContent'
                      style={{ position: 'relative' }}
                    >
                      <div
                        className={`${
                          tripType === 'Round Trip'
                            ? 'search-input-box departure'
                            : 'search-input-box departure RoundDate '
                        }`}
                      >
                        <div
                          onClick={() => setDateRangeOpen(true)}
                          style={{
                            position: 'absolute',
                            left: '0px',
                            right: '0px',
                            width: '100%',
                            height: '100%'
                          }}
                        ></div>
                        <label
                          className='form-label'
                          onClick={() => setDateRangeOpen(true)}
                        >
                          Travel Date
                        </label>
                        <div
                          className='form-holder'
                          onClick={() => setDateRangeOpen(true)}
                        >
                          <input
                            className='autocomplete-airport inp-text'
                            type='text'
                            name='departure_date'
                            onFocus={() => setDateRangeOpen(true)}
                            value={
                              formData.departureDate
                                ? moment(formData.departureDate).format(
                                    'DD MMM YYYY'
                                  )
                                : formData.departureDate
                            }
                            placeholder=''
                            required
                          />
                          <p>
                            <span>
                              {formData.departureDate
                                ? moment(formData.departureDate).format('dddd')
                                : ''}
                            </span>
                          </p>
                        </div>
                        <DateSelector
                          dateRangeOpen={dateRangeOpen}
                          setDateRangeOpen={setDateRangeOpen}
                          handleOnchangeDate={handleOnchangeDate}
                        />
                      </div>
                      {tripType === 'Round Trip' && (
                        <div
                          className='search-input-box departure'
                          style={{ position: 'relative' }}
                        >
                          <label className='form-label'>Return Date</label>
                          <div className='form-holder'>
                            <div
                              onClick={() => setDateEndOpen(true)}
                              style={{
                                position: 'absolute',
                                left: '0px',
                                right: '0px',
                                width: '100%',
                                height: '100%'
                              }}
                            ></div>
                            <input
                              className='autocomplete-airport inp-text'
                              type='text'
                              name='departure_date'
                              onFocus={() => setDateEndOpen(true)}
                              value={
                                formData.returnDate
                                  ? moment(formData.returnDate).format(
                                      'DD MMM YYYY'
                                    )
                                  : formData.returnDate
                              }
                              placeholder=''
                              required
                            />
                            <p>
                              <span>
                                {formData.returnDate
                                  ? moment(formData.returnDate).format('dddd')
                                  : ''}
                              </span>
                            </p>
                            <EndDateSelector
                              dateRangeOpen={endOpen}
                              formData={formData}
                              setDateRangeOpen={setDateEndOpen}
                              handleOnchangeDate={handleOnchangeEndOpen}
                            />
                          </div>
                        </div>
                      )}
                      <div
                        className='search-input-box  traveler'
                        style={{ position: 'relative' }}
                      >
                        <div
                          onClick={() => setGuestCounterOpen(true)}
                          style={{
                            position: 'absolute',
                            left: '0px',
                            right: '0px',
                            width: '100%',
                            height: '100%'
                          }}
                        ></div>
                        <label className='form-label'> Traveller & Class</label>
                        <div
                          className='form-holder'
                          onClick={() => setGuestCounterOpen(true)}
                        >
                          <input
                            className='autocomplete-airport inp-text'
                            type='text'
                            name='departure_date'
                            value={
                              totalTravelers
                                ? `${totalTravelers} Traveler${
                                    totalTravelers > 1 ? 's' : ''
                                  }`
                                : ''
                            }
                            placeholder=''
                            required
                          />
                          <p>
                            <span>{formData.travelClass}</span>
                          </p>
                        </div>
                        {guestCounterOpen && (
                          <div
                            onClick={() => setGuestCounterOpen(false)}
                            className='GuestCounter-center'
                          ></div>
                        )}
                        <GuestCounter
                          guestCounterOpen={guestCounterOpen}
                          setGuestCounterOpen={setGuestCounterOpen}
                          formData={formData}
                          setFormData={setFormData}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-lg-7 col-md-12 col-12 enquiry-form'>
                  <div className='row'>
                    <div className='col-md-4  m-b-10'>
                      <div className='form-group'>
                        <input
                          type='text'
                          className='form-control'
                          name='full_name'
                          placeholder='Full Name'
                          value={formData.full_name}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className='col-md-4  m-b-10'>
                      <div className='form-group'>
                        <input
                          type='text'
                          className='form-control'
                          name='contact'
                          placeholder='Mobile Number'
                          pattern='^\d*$'
                          value={formData.contact}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className='col-md-4'>
                      <div className='form-group'>
                        <input
                          type='text'
                          className='form-control'
                          name='email'
                          placeholder='Email ID'
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                        <input
                          type='hidden'
                          name='product_type'
                          value='hotels'
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-lg-6 col-md-12 col-12'>
                  <div className='quota-box'>
                    <div className='q-label'>
                      <p>Select A Fare Type:</p>
                    </div>
                    <div className='radio-group'>
                      <label
                        className={`radio-label ${
                          selectedFare === 'Regular' ? 'selected' : ''
                        }`}
                      >
                        <input
                          type='radio'
                          name='Regular'
                          value='Regular'
                          checked={selectedFare === 'Regular'}
                          onChange={e => setSelectedFare(e.target.value)}
                          className='radio-input'
                        />
                        <span className='custom-radio'></span>
                        Regular
                      </label>

                      <label
                        className={`radio-label ${
                          selectedFare === 'Student' ? 'selected' : ''
                        }`}
                      >
                        <input
                          type='radio'
                          name='Student'
                          value='Student'
                          checked={selectedFare === 'Student'}
                          onChange={e => setSelectedFare(e.target.value)}
                          className='radio-input'
                        />
                        <span className='custom-radio'></span>
                        Student
                      </label>
                    </div>
                  </div>
                </div>
                <div className='col-lg-6 col-md-12 col-12'>
                  <div className='recent-box'>
                    <div id='date'></div>
                  </div>
                </div>
              </div>
              <div className='button-center'>
                <button type='submit' className='btn search-btn'>
                  <FontAwesomeIcon icon={faPlane} className='planeIcon' />
                  <span className='button-text'>ENQUIRE NOW</span>
                </button>
              </div>
            </form>
            {success && (
              <div className='success-popup'>Thank you for your enquiry!</div>
            )}
          </div>
        </div>
        {/* <div className='flight-slider'>
          <Slider {...settings}>
            {flightsForm[0]?.displayBackground.map((item, index) => (
              <div key={index}>
                <img
                  src={item}
                  style={{
                    filter: 'brightness(0.5)',
                    width: '100%'
                  }}
                  alt={`Slide ${index}`}
                  className='flights-images'
                />
              </div>
            ))}
          </Slider>
        </div> */}
      </div>
      <SliderImages data={sliderImages[0]?.displayImages || []} />
    </div>
  )
}
export default Flights
